import { useParams } from "react-router-dom";
import { ActionBar } from "../components/ActionBar";
import EventSection from "../components/EventSection";
import TeamProfileSection from "../components/TeamProfileSection";
import UserListSection from "../components/UserListSection";

export default function TeamInternal() {
  let { teamId } = useParams();

  return (
    <div className="flex grow flex-col items-center">
      <div className="flex w-full lg:w-3/4">
        <ActionBar teamId={teamId} />
      </div>
      {/* Projects */}
      <div className="flex mt-5 w-full lg:w-3/4">
        <TeamProfileSection />
      </div>
      {/* Members */}
      <div className="flex mt-10 w-full lg:w-3/4 ">
        <UserListSection teamId={teamId} />
      </div>
      {/* Activity */}
      <div className="flex mt-10 w-full lg:w-3/4 ">
        <EventSection teamId={teamId} />
      </div>
    </div>
  );
}
